<template>
  <div>
    <v-dialog name="dialog" />
    <div class="admin_title">推荐管理</div>
    <!--右侧内容-->
    <div class="gj_right">
      <div class="gj_top_class">
        <a @click="to('banner', 'void')" class="btn btn_add">新增推荐</a>
      </div>
      <div class="gj_list">
        <h5 class="none_ts" v-if="pages <= 0 || !tableData">
          <img src="@/assets/images/none_data.jpg" alt="">
        </h5>
        <BylTable v-bind:model="tableData" :opts="opts" v-if="tableData.data.length > 0">
          <span slot="edit" @click="to('banner', props.item.id)" class="xo-table-btn" slot-scope="props">编辑</span>
          <span slot="del" @click="del(props.item)" class="xo-table-btn" slot-scope="props">删除</span>
        </BylTable>
        <paginate v-if="pages > 0" :click-handler="clickCallback" :page-count=pages
                  :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                  :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                  :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                  :first-last-button=$global.paginationOptions.first_last_button
                  :active-class=$global.paginationOptions.active_class
                  :disabled-class=$global.paginationOptions.disabled_class
                  :first-button-text=$global.paginationOptions.first_button_text
                  :last-button-text=$global.paginationOptions.last_button_text
                  :prev-text=$global.paginationOptions.prev_text
                  :next-text=$global.paginationOptions.next_text></paginate>
      </div>
    </div>
    <!--/右侧内容-->
    <div class="clear"></div>
  </div>
</template>
<script>
  import api from '@/api/index'
  import config from '@/config/index'
  import BylTable from '@/components/common/table/index.vue'
  import Paginate from 'vuejs-paginate'
  import { mapState } from 'vuex'
  export default {
    components: { Paginate, BylTable },
    mounted () {
      this.search(this.filters)
    },
    data () {
      return {
        lists: [],
        filters: {
          pageNo: 1,
          pageSize: 12
        },
        pages: 0,
        tableData: {
          columns: [
            {
              field: 'title',
              title: '标题',
              colWidth: 600
            }, {
              field: 'sort',
              title: '排序',
              colWidth: 80
            }
          ],
          data: [],
          actions: ['edit', 'del']
        },
        opts: {
          checkBoxMode: false
        }
      }
    },
    computed: {
      ...mapState('orgstructure', ['menus'])
    },
    methods: {
      to (path, id) {
        this.$router.push({
          path: path + '/' + id
        })
      },
      clickCallback (pageNum)  {
        this.filters.pageNo = pageNum
        this.search(this.filters)
      },
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: '删除',
          text: '确认删除吗？',
          buttons: [
            {
              title: '确认',
              default: true,
              handler: that.$utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      del (item) {
        if (item) {
          var that = this
          this.confirmBox({
            yes: function () {
              api.post(config.bylBaseCenterPath, '/recommendinfo/delete', {id: item.id}, function (r) { // 正常
                that.$toasted.show('删除成功')
                that.search(that.filters)
                that.$modal.hide('dialog')
              })
            }
          })
        }
      },
      search (filters) {
        if (!filters) { filters = {} }
        var that = this
        api.post(config.bylBaseCenterPath, '/recommendinfo/search', filters, function (r) { // 正常
          that.pages = Math.ceil(r.cntData / that.filters.pageSize)
          that.tableData.data = r.data
        })
      }
    }
  }
</script>
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/org/banner/list.vue